import { Injectable } from '@angular/core';

export class Testimonial {
	public quote: string;
	public author: string;
	public stars: number;
}

@Injectable({
	providedIn: 'root'
})
export class TestimonialService {

	private allTestimonials: Testimonial[] = [
		{
			quote: 'Rohan was so <strong>incredibly awesome!</strong> I am new to the whole storage world and he answered every question and made the experience so pleasant and easy',
			author: 'John Doe',
			stars: 4
		},
		{
			quote: 'I wish to express my pleasure in dealing with Rent-A-Store. You are a very professional and secure company, not to mention friendly and your professional staff and gate keepers.',
			author: 'Cheryl Stanton',
			stars: 5
		},
		{
			quote: 'As always, we thank Rent-A-Store for being the only place that I would entrust to store my belongings due to its efficient service, security and wonderful staff!',
			author: 'Bronwyn Jacob',
			stars: 5
		},
		{
			quote: 'I’d just like to pay my compliments to your driver who assisted me with my “move-in” move yesterday. He was really helpful and pleasant and was a pleasure to work with.',
			author: 'Lee',
			stars: 5
		},
		{
			quote: 'I wanted to thank you for the amazing service you gave me. You and your team are amazing!!! I just want to commend and send a special thank you to Titus and Frans – they were very professional and respectful. So from start to end – you were GREAT!!!!!!',
			author: 'Phihlile Cele',
			stars: 5
		},
	]

	constructor() {
		// ensure all testimonials have valid number of stars
		for (let testimonial of this.allTestimonials) {
			if (testimonial.stars > 5) testimonial.stars = 5
			if (testimonial.stars < 1) testimonial.stars = 1

			// TODO what star-value to we give non-numbers? A default, none, or do we omit the entire testimonial?
			if (Number.isNaN(testimonial.stars)) testimonial.stars = 5
		}
	}

	public getTestimonials(): Promise<Testimonial[]> {
		return new Promise((resolve, reject) => {
			resolve(this.allTestimonials)
		})
	}
}
